import { inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { plainToClass } from 'class-transformer';
import { PermissionService } from '@auth';
import { Observable } from 'rxjs';
import { EventVenueService } from '@core/services';
import { EventVenueEntity } from '@core/entities';

export class UseEventVenue {
  private readonly _permissionService = inject(PermissionService);
  private readonly _eventVenueService = inject(EventVenueService);

  getAllEventVenues(): Observable<EventVenueEntity[]> {
    return this._eventVenueService.find().pipe(
      map((response) => {
        if (response) {
          return response.map((item: any) => {
            return plainToClass(EventVenueEntity, item as EventVenueEntity);
          });
        }
        return [];
      }),
    );
  }

  getEventBYId(id: number): Observable<EventVenueEntity> {
    return this._eventVenueService.get(id).pipe(
      map((response) => {
        if (response) {
          return plainToClass(EventVenueEntity, response as EventVenueEntity);
        }
        return null;
      }),
    );
  }

  createEventVenue(data: any): Observable<EventVenueEntity> {
    return this._eventVenueService.create(data).pipe(
      map((response) => {
        if (response) {
          return plainToClass(EventVenueEntity, response.Venue as EventVenueEntity);
        }
        return null;
      }),
    );
  }

  updateEventVenue(id: number, data: any): Observable<any> {
    return this._eventVenueService.update(id, data).pipe(
      map((response) => {
        if (response) {
          return plainToClass(EventVenueEntity, response.venue as EventVenueEntity);
        }
        return null;
      }),
    );
  }

  deleteEventVenue(id: number): Observable<any> {
    return this._eventVenueService.delete(id);
  }
}
